console.info('[members-mobile-auth] bridge implementation loaded=stub')

export function getMemberMobileAuthBridge() {
  return {
    bridgeType: 'stub',
    addAppUrlOpenListener: async () => ({ remove: async () => {} }),
    addAppStateChangeListener: async () => ({ remove: async () => {} }),
    getLaunchUrl: async () => ({ url: null }),
    openBrowser: async () => {},
    closeBrowser: async () => {},
  }
}
